import { requestWithRetry } from '../axios'

export const addItemToOrder = async (
  fnb_uid: string,
  item: {
    item_id: string
    name: string
    quantity: number
    price: number
    is_double_measure?: boolean
  },
) => {
  return await requestWithRetry(`fnb/order/${fnb_uid}`, 'post', item)
}

export const updateItemQuantity = async (
  item_uid: string,
  quantity: number,
) => {
  return await requestWithRetry(`fnb/item/${item_uid}`, 'patch', { quantity })
}

export const removeItem = async (item_uid: string) => {
  return await requestWithRetry(`fnb/item/${item_uid}`, 'delete')
}

// Backend re-reads pickup_location_ref at submit time, so this works until payment.
export const updatePickupLocation = async (
  fnb_uid: string,
  location_id: string,
) => {
  return await requestWithRetry(`fnb/order/${fnb_uid}`, 'patch', {
    location_id,
  })
}

export const deleteOrder = async (fnb_uid: string) => {
  return await requestWithRetry(`fnb/order/${fnb_uid}`, 'delete')
}

export const getOrderDetails = async (fnb_uid: string) => {
  return await requestWithRetry(`fnb/order/${fnb_uid}`, 'get')
}
